<template>
  <header class="main-header">
    <div class="logo">
      <router-link to="/library">
        <img src="@/assets/logo.png" alt="Logo" />
      </router-link>
    </div>
    <nav class="nav-links">
      <router-link to="/library">Início</router-link>
      <a href="#" @click.prevent="logout">Logout</a>
    </nav>
  </header> 
</template>

<script>
import '@/styles/Header.css';
export default {
  name: 'Header',
  methods: {
    logout() {
      // Remove o token ou dados de autenticação
      localStorage.removeItem('token');
      // Redireciona para a tela de login
      this.$router.push('/');
    }
  }
}
</script>
